<mat-card [class.promotion]="isPromotion()" class="wrapper-product-card-small">
  <div [class.container-promotion]="isPromotion()" class="header-row">
    @if (isPromotion()) {
      <span>Lekkerland Tipp</span>
    }
  </div>

  <div class="wrapper-content">

    <a [link]="product()" uiProductLink [enableProductClickTracking]="enableProductClickTracking()" [position]="position()">
      @if (product().images.length) {
        <img [alt]="product().images[0].large" [src]="product().images[0].large">
      }
    </a>

    <span class="product-name">{{ product().details.name }}</span>

    <div class="wrapper-attributes">
      <span>VE: {{ product().details.packagingUnit }}</span>
      <span>Art.-Nr.: {{ product().sku }}</span>

      @let prices = product().prices;

      @if (prices && !prices.redacted) {
        <span>VK: <ui-product-prices-formatter [showThousandthsPlace]="true" [price]="prices.singleUnit"></ui-product-prices-formatter></span>
      }
    </div>

    <div class="wrapper-actions">
      <ui-add-to-cart-small [sku]="product().sku" [position]="position()" [product]="product()"></ui-add-to-cart-small>
    </div>

  </div>
</mat-card>
